import playIcon from '@/assets/images/play.svg';
import pauseIcon from '@/assets/images/pause.svg';
import '@/components/reusable/NSelect';
import '@/components/WPreloader/WPreloader';
import './types.js';
import { UITrackMixin } from '../../mixins/UITrackMixin.js';
import { profileStore } from '../../stores/profile.js';
import { music } from "@/services/Music";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  :host {
    --play-button-size: 36px;
    display: flex;
    width: 100%;
    align-items: center;
  }
  
  w-preloader {
    margin-right: 10px;
    width: 36px;
    height: 36px;
  }

  .toggler {
    margin-right: 10px;
    width: var(--play-button-size);
    min-width: var(--play-button-size);
    height: var(--play-button-size);
    /*background-color: dodgerblue;*/
    background-color: var(--color-focus);
    border-radius: 6px;
    outline: none;
    border-color: transparent;
    background-image: url(${playIcon});
    background-position: center;
    background-size: 20px;
    background-repeat: no-repeat;
    color: white;
  }
  
  :host(.playing) .toggler {
    background-image: url(${pauseIcon});
  }
  
  .content {
    display: flex;
    align-items: center;
    flex-grow: 1;
    min-width: 0;
  }

  .title {
    flex-grow: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .invisible {
    visibility: hidden;
  }
  
  n-select::part(intro) {
    display: none;
  }
  
  .context-toggler {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 20px;
    height: 20px;
    outline: none;
    border: none;
    cursor: pointer;
    background-color: #545565;
    margin-left: 10px;
  }
  
  .dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: white;
  }
  
  .duration:empty() {
    dispaly: none;
  }
`);
export class WTrack extends UITrackMixin(HTMLElement) {
    static tag = 'w-track';
    playlist;
    /**
     * @param {Track} track
     * @param {Playlist} playlist
     * */
    constructor({ track, playlist } = {}) {
        super({ track, playlist });
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
        this.playlist = playlist;
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <div class="content">
        <div class="title"></div>
<!--        <div class="duration"></div>-->
      </div>
      <div class="duration"></div>
    `;
        super.connectedCallback();
        const { title, duration } = this.track;
        const $title = /** @type {HTMLDivElement} */ this.shadowRoot.querySelector('.title');
        $title.innerText = title;
        $title.title = title;
        // const $duration = this.shadowRoot.querySelector('.duration');
        // $duration.title = $duration.innerText = this.#formatDuration(duration);
        if (this.track.trackUploadStatus === 'pending') {
            const preloaderEl = document.createElement('w-preloader');
            this.shadowRoot.prepend(preloaderEl);
            this.#initStatusChecking();
            return;
        }
        this.#processReadyTrack();
    }
    visualPause() {
        this.#togglePlayingStyles(false);
    }
    visualPlay() {
        this.#togglePlayingStyles(true);
    }
    visualStop() {
        this.#togglePlayingStyles(false);
    }
    #addTrackToPlaylists(playlists) {
        music.addTrackToPlaylists(this.track.id, playlists);
    }
    /** @param {number} duration */
    #formatDuration(duration) {
        const fullHours = Math.floor(duration / 1000 / 60 / 60);
        const fullMinutes = Math.floor((duration - fullHours * 1000 * 60 * 60) / 1000 / 60);
        const fullSeconds = Math.floor((duration - fullHours * 60 * 60 * 1000 - fullMinutes * 60 * 1000) / 1000);
        const str = `${fullMinutes.toString().padStart(2, '0')}:${fullSeconds.toString().padStart(2, '0')}`;
        return fullHours > 0 ? `${fullHours}:${str}` : str;
    }
    #initStatusChecking() {
        const interval = setInterval(() => {
            music.checkTrackStatus(this.track.id)
                .then(({ response, body }) => {
                if (!response.ok)
                    return;
                if (body.status === 'uploaded') {
                    this.#processReadyTrack();
                    clearInterval(interval);
                }
            });
        }, 5000);
    }
    #processReadyTrack() {
        this.shadowRoot.querySelector('w-preloader')?.remove();
        const buttonEl = document.createElement('button');
        buttonEl.classList.add('toggler');
        this.shadowRoot.prepend(buttonEl);
        this.#processSongPlayToggle();
        const selectorEl = document.createElement('n-select');
        let opts = 'addToPlaylist:Добавить в плейлист';
        if (this.playlist.isOwnPlaylist) {
            opts += '|deleteFromPlaylist:Удалить из плейлиста';
        }
        selectorEl.setAttribute('options', opts);
        selectorEl.setAttribute('modal-title', this.track.title);
        selectorEl.setAttribute('query', `track${this.track.id}`);
        selectorEl.addEventListener('change', event => {
            switch (event.target.value) {
                case 'addToPlaylist':
                    music.loadPlaylists(profileStore.profile.id)
                        .then(({ response, body: playlists }) => {
                        if (!response.ok) {
                            throw new Error('Не удалось загрузить плейлисты. Попробуйте повторить позже.');
                        }
                        const playlistSelectEl = document.createElement('n-select');
                        playlistSelectEl.setAttribute('multiple', '');
                        playlistSelectEl.setAttribute('modal-title', 'Выберите плейлист, в который хотите добавить трек');
                        playlistSelectEl.setAttribute('options', playlists.filter(({ type }) => type === 'user_created').map(({ id, title }) => {
                            return `${id}:${title}`;
                        }).join('|'));
                        document.body.append(playlistSelectEl);
                        playlistSelectEl.open();
                        playlistSelectEl.addEventListener('change', event => {
                            this.#addTrackToPlaylists(event.target.value?.map(i => +i));
                            event.target.remove();
                        }, { once: true });
                        playlistSelectEl.addEventListener('close', event => {
                            event.target.remove();
                        }, { once: true });
                    });
                    break;
                case 'deleteFromPlaylist':
                    music.deleteFromPlaylist(this.track.id, this.playlist.id)
                        .then(() => this.dispatchEvent(new CustomEvent('deleteFromPlaylist', { bubbles: true, composed: true })));
                    break;
            }
        });
        this.shadowRoot.append(selectorEl);
        const togglerEl = document.createElement('button');
        togglerEl.classList.add('context-toggler');
        togglerEl.addEventListener('click', () => {
            selectorEl.open();
        });
        this.shadowRoot.append(togglerEl);
        const dotEl = document.createElement('div');
        dotEl.classList.add('dot');
        togglerEl.append(dotEl, dotEl.cloneNode(), dotEl.cloneNode());
    }
    #processSongPlayToggle() {
        const $toggler = /** @type {HTMLButtonElement} */ this.shadowRoot.querySelector('.toggler');
        $toggler.addEventListener('click', () => {
            if (this.isTrackPlaying)
                this.pause();
            else
                this.play();
        });
    }
    /** @param {boolean} playing */
    #togglePlayingStyles(playing) {
        const method = playing ? 'add' : 'remove';
        this.classList[method]('playing');
    }
}
customElements.define(WTrack.tag, WTrack);
